export default {
  id: "consejeria-matrimonial",
  type: "short_study",
  titleKey: "programs.consejeria_matrimonial.title",
  descriptionKey: "programs.consejeria_matrimonial.desc",
  durationDays: 6,
  // Redistribuido desde el bloque "Recursos" de /formacion/ (2026-08-11) — el PDF fuente
  // de este programa, contextual a quien ya lo está viendo.
  resourcePdfs: [
    { titleKey: "resources_marriage_counseling", href: "/pdfs/Claves-Consejeria-Matrimonial.pdf" },
  ],
  modules: [
    {
      id: "mod-1",
      titleKey: "programs.consejeria_matrimonial.mod1.title",
      lessons: [
        {
          id: "les-1",
          titleKey: "programs.consejeria_matrimonial.mod1.les1.title",
          contentBlocks: [
            {
              type: "text",
              textKey: "programs.consejeria_matrimonial.mod1.les1.intro",
            },
            {
              type: "verse",
              reference: "Santiago 1:19",
              referenceKey: "programs.consejeria_matrimonial.mod1.les1.reference1",
              textKey: "programs.consejeria_matrimonial.mod1.les1.verse1",
            },
            {
              type: "verse",
              reference: "Efesios 4:29",
              referenceKey: "programs.consejeria_matrimonial.mod1.les1.reference2",
              textKey: "programs.consejeria_matrimonial.mod1.les1.verse2",
            },
            {
              type: "verse",
              reference: "Proverbios 15:1",
              referenceKey: "programs.consejeria_matrimonial.mod1.les1.reference3",
              textKey: "programs.consejeria_matrimonial.mod1.les1.verse3",
            },
          ],
          questions: [
            {
              id: "m1l1-q1",
              type: "reflection",
              promptKey: "programs.consejeria_matrimonial.mod1.les1.q1",
            },
            {
              id: "m1l1-q2",
              type: "application",
              promptKey: "programs.consejeria_matrimonial.mod1.les1.q2",
            },
          ],
        },
        {
          id: "les-2",
          titleKey: "programs.consejeria_matrimonial.mod1.les2.title",
          contentBlocks: [
            {
              type: "text",
              textKey: "programs.consejeria_matrimonial.mod1.les2.intro",
            },
            {
              type: "verse",
              reference: "Colosenses 3:13",
              referenceKey: "programs.consejeria_matrimonial.mod1.les2.reference1",
              textKey: "programs.consejeria_matrimonial.mod1.les2.verse1",
            },
            {
              type: "verse",
              reference: "Efesios 4:32",
              referenceKey: "programs.consejeria_matrimonial.mod1.les2.reference2",
              textKey: "programs.consejeria_matrimonial.mod1.les2.verse2",
            },
            {
              type: "verse",
              reference: "Mateo 18:21-22",
              referenceKey: "programs.consejeria_matrimonial.mod1.les2.reference3",
              textKey: "programs.consejeria_matrimonial.mod1.les2.verse3",
            },
          ],
          questions: [
            {
              id: "m1l2-q1",
              type: "reflection",
              promptKey: "programs.consejeria_matrimonial.mod1.les2.q1",
            },
            {
              id: "m1l2-q2",
              type: "application",
              promptKey: "programs.consejeria_matrimonial.mod1.les2.q2",
            },
          ],
        },
        {
          id: "les-3",
          titleKey: "programs.consejeria_matrimonial.mod1.les3.title",
          contentBlocks: [
            {
              type: "text",
              textKey: "programs.consejeria_matrimonial.mod1.les3.intro",
            },
            {
              type: "verse",
              reference: "Efesios 5:22-33",
              referenceKey: "programs.consejeria_matrimonial.mod1.les3.reference1",
              textKey: "programs.consejeria_matrimonial.mod1.les3.verse1",
            },
            {
              type: "verse",
              reference: "1 Pedro 3:1-7",
              referenceKey: "programs.consejeria_matrimonial.mod1.les3.reference2",
              textKey: "programs.consejeria_matrimonial.mod1.les3.verse2",
            },
            {
              type: "verse",
              reference: "Génesis 2:18",
              referenceKey: "programs.consejeria_matrimonial.mod1.les3.reference3",
              textKey: "programs.consejeria_matrimonial.mod1.les3.verse3",
            },
          ],
          questions: [
            {
              id: "m1l3-q1",
              type: "reflection",
              promptKey: "programs.consejeria_matrimonial.mod1.les3.q1",
            },
            {
              id: "m1l3-q2",
              type: "application",
              promptKey: "programs.consejeria_matrimonial.mod1.les3.q2",
            },
          ],
        },
      ],
    },
    {
      id: "mod-2",
      titleKey: "programs.consejeria_matrimonial.mod2.title",
      lessons: [
        {
          id: "les-4",
          titleKey: "programs.consejeria_matrimonial.mod2.les4.title",
          contentBlocks: [
            {
              type: "text",
              textKey: "programs.consejeria_matrimonial.mod2.les4.intro",
            },
            {
              type: "verse",
              reference: "Hebreos 13:4",
              referenceKey: "programs.consejeria_matrimonial.mod2.les4.reference1",
              textKey: "programs.consejeria_matrimonial.mod2.les4.verse1",
            },
            {
              type: "verse",
              reference: "1 Corintios 7:3-5",
              referenceKey: "programs.consejeria_matrimonial.mod2.les4.reference2",
              textKey: "programs.consejeria_matrimonial.mod2.les4.verse2",
            },
            {
              type: "verse",
              reference: "Proverbios 5:18-19",
              referenceKey: "programs.consejeria_matrimonial.mod2.les4.reference3",
              textKey: "programs.consejeria_matrimonial.mod2.les4.verse3",
            },
          ],
          questions: [
            {
              id: "m2l4-q1",
              type: "reflection",
              promptKey: "programs.consejeria_matrimonial.mod2.les4.q1",
            },
            {
              id: "m2l4-q2",
              type: "application",
              promptKey: "programs.consejeria_matrimonial.mod2.les4.q2",
            },
          ],
        },
        {
          id: "les-5",
          titleKey: "programs.consejeria_matrimonial.mod2.les5.title",
          contentBlocks: [
            {
              type: "text",
              textKey: "programs.consejeria_matrimonial.mod2.les5.intro",
            },
            {
              type: "verse",
              reference: "Eclesiastés 4:12",
              referenceKey: "programs.consejeria_matrimonial.mod2.les5.reference1",
              textKey: "programs.consejeria_matrimonial.mod2.les5.verse1",
            },
            {
              type: "verse",
              reference: "Mateo 6:33",
              referenceKey: "programs.consejeria_matrimonial.mod2.les5.reference2",
              textKey: "programs.consejeria_matrimonial.mod2.les5.verse2",
            },
            {
              type: "verse",
              reference: "Josué 24:15",
              referenceKey: "programs.consejeria_matrimonial.mod2.les5.reference3",
              textKey: "programs.consejeria_matrimonial.mod2.les5.verse3",
            },
          ],
          questions: [
            {
              id: "m2l5-q1",
              type: "reflection",
              promptKey: "programs.consejeria_matrimonial.mod2.les5.q1",
            },
            {
              id: "m2l5-q2",
              type: "application",
              promptKey: "programs.consejeria_matrimonial.mod2.les5.q2",
            },
          ],
        },
        {
          id: "les-6",
          titleKey: "programs.consejeria_matrimonial.mod2.les6.title",
          contentBlocks: [
            {
              type: "text",
              textKey: "programs.consejeria_matrimonial.mod2.les6.intro",
            },
            {
              type: "verse",
              reference: "Mateo 6:24",
              referenceKey: "programs.consejeria_matrimonial.mod2.les6.reference1",
              textKey: "programs.consejeria_matrimonial.mod2.les6.verse1",
            },
            {
              type: "verse",
              reference: "Proverbios 21:5",
              referenceKey: "programs.consejeria_matrimonial.mod2.les6.reference2",
              textKey: "programs.consejeria_matrimonial.mod2.les6.verse2",
            },
            {
              type: "verse",
              reference: "1 Timoteo 6:6-10",
              referenceKey: "programs.consejeria_matrimonial.mod2.les6.reference3",
              textKey: "programs.consejeria_matrimonial.mod2.les6.verse3",
            },
          ],
          questions: [
            {
              id: "m2l6-q1",
              type: "reflection",
              promptKey: "programs.consejeria_matrimonial.mod2.les6.q1",
            },
            {
              id: "m2l6-q2",
              type: "application",
              promptKey: "programs.consejeria_matrimonial.mod2.les6.q2",
            },
          ],
        },
      ],
    },
  ],
};
